import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// const apiUrl = process.env.REACT_APP_API_ROOT_URL;
export const packageSlide = createSlice({
    name: "packageReducer",
    initialState: {
        packageListData: [],
        packageSelectedItemsData: [],
        editPackageCartItemUuid: null,

        packageDetailSuccess: false,
        packageDetailFail: false,
        packageDetailResponseData: null,
        packageDetailErrorDetailData: null,

        snackBarAddToCart: false,
    },
    reducers: {
        doGetPackageListSuccess: (state, action) => {
            state.packageListData = action.payload.data;
        },
        doGetPackageListFail: (state, action) => {
            state.packageListData = [];
        },
        doGetPackageDetailSuccess: (state, action) => {
            state.packageDetailSuccess = true;
            state.packageDetailFail = false;
            state.packageDetailResponseData = action.payload.data;
        },
        doGetPackageDetailFail: (state, action) => {
            state.packageDetailSuccess = false;
            state.packageDetailFail = true;
            state.packageDetailErrorDetailData = action.payload.data;
        },
        setPackageSelectedItems: (state, action) => {
            state.packageSelectedItemsData = action.payload;
        },
        setEditPackageCartItemUuid: (state, action) => {
            state.editPackageCartItemUuid = action.payload;
        },
        setSnackBarAddToCart: (state, action) => {
            state.snackBarAddToCart = action.payload;
        },
        resetPackageStateSuccess: (state, action) => {
            state.packageDetailSuccess = action.payload;
            state.packageDetailFail = action.payload;
            state.packageDetailErrorDetailData = null;
        },
    },
});

export const doGetPackageList = (param) => async (dispatch) => {
    try {
        let url = `/api/customer/package`;

        const response = await axios.get(url);
        dispatch(doGetPackageListSuccess(response.data));
    } catch (error) {
        dispatch(doGetPackageListFail(error.response));
    }
};

export const doGetPackageDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/package/${param.package_id}`;

        const response = await axios.get(url);
        dispatch(doGetPackageDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetPackageDetailFail(error.response));
    }
};

export const doSetPackageSelectedItems = (param) => async (dispatch) => {
    dispatch(setPackageSelectedItems(param));
};

export const doSetEditPackageCartItemUuid = (param) => async (dispatch) => {
    dispatch(setEditPackageCartItemUuid(param));
};

export const doSetSnackBarAddToCart = (param) => async (dispatch) => {
    dispatch(setSnackBarAddToCart(param));
};

export const resetPackageState = () => async (dispatch) => {
    dispatch(resetPackageStateSuccess(false));
};

export const { 
    doGetPackageListSuccess, 
    doGetPackageListFail,
    doGetPackageDetailSuccess,
    doGetPackageDetailFail,
    setPackageSelectedItems,
    setEditPackageCartItemUuid,
    setSnackBarAddToCart,
    resetPackageStateSuccess,
} = packageSlide.actions;

export const getPackageList = (state) => state.packageReducer?.packageListData;
export const getPackageSelectedItemsData = (state) => state.packageReducer?.packageSelectedItemsData;
export const getEditPackageCartItemUuid = (state) => state.packageReducer?.editPackageCartItemUuid;

export const getPackageDetail = (state) => state.packageReducer?.packageDetailResponseData;
export const getPackageDetailErrorDetailData = (state) => state.packageReducer?.packageDetailErrorDetailData;
export const getPackageDetailSuccess = (state) => state.packageReducer?.packageDetailSuccess;
export const getPackageDetailFail = (state) => state.packageReducer?.packageDetailFail;

export const getSnackBarAddToCart = (state) => state.packageReducer?.snackBarAddToCart;

export default packageSlide.reducer;
